<ng-template #cardTpl let-item="item" let-featured="featured">
  <article
    class="news-card"
    [class.news-card--featured]="featured"
    [attr.role]="item.link ? 'link' : 'button'"
    tabindex="0"
    (click)="item.link ? openLink(item) : openDetail(item)"
    (keyup.enter)="item.link ? openLink(item) : openDetail(item)"
  >
    <div
      class="news-card__media"
      [class.news-card__media--logo]="item.isLogo"
      [class.news-card__media--dark]="item.dark"
      *ngIf="item.image"
    >
      <img [src]="item.image" [alt]="'landing.news.items.' + item.key + '.title' | translate" />
    </div>
    <div class="news-card__top">
      <span class="news-card__new" *ngIf="featured">{{ 'landing.news.new_badge' | translate }}</span>
      <span class="news-card__badge" [attr.data-cat]="item.category">
        {{ 'landing.news.categories.' + item.category | translate }}
      </span>
      <span class="news-card__date">{{ 'landing.news.items.' + item.key + '.date' | translate }}</span>
      <span class="news-card__external" *ngIf="item.link" aria-hidden="true">↗</span>
    </div>
    <h3 class="news-card__title">{{ 'landing.news.items.' + item.key + '.title' | translate }}</h3>
    <p class="news-card__text">{{ 'landing.news.items.' + item.key + '.text' | translate }}</p>
  </article>
</ng-template>

<section class="landing-news" id="news">
  <div class="landing-news__inner">
    <div class="landing-news__head">
      <h2 class="landing-news__title">{{ 'landing.news.title' | translate }}</h2>
      <p class="landing-news__sub">{{ 'landing.news.intro' | translate }}</p>
    </div>

    <div class="landing-news__filters">
      <button
        type="button"
        class="filter-chip"
        [class.filter-chip--active]="activeFilter === 'all'"
        (click)="setFilter('all')"
      >
        {{ 'landing.news.filters.all' | translate }}
      </button>
      <button
        type="button"
        class="filter-chip"
        *ngFor="let cat of categories"
        [attr.data-cat]="cat"
        [class.filter-chip--active]="activeFilter === cat"
        (click)="setFilter(cat)"
      >
        {{ 'landing.news.categories.' + cat | translate }}
      </button>
    </div>

    <div class="landing-news__hero-row" *ngIf="filteredItems.length > 1">
      <ng-container *ngTemplateOutlet="cardTpl; context: { item: filteredItems[0], featured: true }"></ng-container>

      <div class="landing-news__secondary" *ngIf="secondaryItems.length">
        <ng-container *ngFor="let item of secondaryItems">
          <ng-container *ngTemplateOutlet="cardTpl; context: { item: item, featured: false }"></ng-container>
        </ng-container>
      </div>
    </div>

    <div class="landing-news__grid" *ngIf="filteredItems.length > 1 && restItems.length">
      <ng-container *ngFor="let item of restItems">
        <ng-container *ngTemplateOutlet="cardTpl; context: { item: item, featured: false }"></ng-container>
      </ng-container>
    </div>

    <div class="landing-news__single" *ngIf="filteredItems.length === 1">
      <ng-container *ngTemplateOutlet="cardTpl; context: { item: filteredItems[0], featured: false }"></ng-container>
    </div>

  </div>

  <div class="news-detail-overlay" *ngIf="selected as item" (click)="closeDetail()">
    <div class="news-detail" (click)="$event.stopPropagation()">
      <button type="button" class="news-detail__close" (click)="closeDetail()" [attr.aria-label]="'common.close' | translate">&times;</button>

      <div
        class="news-detail__media"
        [class.news-detail__media--logo]="item.isLogo"
        [class.news-detail__media--dark]="item.dark"
        [class.news-detail__media--placeholder]="!item.image"
      >
        <img *ngIf="item.image" [src]="item.image" [alt]="'landing.news.items.' + item.key + '.title' | translate" />
        <i *ngIf="!item.image" class="fa fa-newspaper" aria-hidden="true"></i>
      </div>

      <div class="news-detail__body">
        <div class="news-detail__top">
          <span class="news-card__badge" [attr.data-cat]="item.category">
            {{ 'landing.news.categories.' + item.category | translate }}
          </span>
          <span class="news-card__date">{{ 'landing.news.items.' + item.key + '.date' | translate }}</span>
        </div>
        <h3 class="news-detail__title">{{ 'landing.news.items.' + item.key + '.title' | translate }}</h3>
        <p class="news-detail__text">{{ 'landing.news.items.' + item.key + '.text' | translate }}</p>
      </div>
    </div>
  </div>
</section>
